import { useTranslation } from 'react-i18next'
import { useTw } from '../../../../../utils/Styles'
import { useProfile } from '../../../../../utils/Profile'
import { isDark, localizeString, useWidgetOpen } from '../../../../../utils'
import { CloseButton } from '../../../CloseButton'

function getBackground(bg: string) {
  if (bg.toLowerCase() === '#1e1e31') {
    return 'https://app.firesquad.io/public/firesquad_colored.svg'
  }

  return isDark(bg)
    ? 'https://app.firesquad.io/public/firesquad_light.svg'
    : 'https://app.firesquad.io/public/firesquad_dark.svg'
}

export function Logo() {
  const tw = useTw()
  const [t] = useTranslation('common')
  const profile = useProfile()
  return (
    <a
      target="_blank"
      className={tw`block`}
      rel="noreferrer noopener"
      href={profile.account.website}
    >
      <img
        alt={t('logo.alt', { name: profile.account.name })}
        src={profile.logoURL || getBackground(profile.background.background)}
        className={tw`select-none w-36 h-12 object-contain object-left-top`}
      />
    </a>
  )
}

export function Header() {
  const tw = useTw()
  const profile = useProfile()
  const { responsive, isMobile, setOpen } = useWidgetOpen()

  return (
    <>
      <div className={tw`flex justify-between pt-8 px-8 w-full`}>
        <Logo />
        {responsive ? (
          <CloseButton
            className={tw`flex focus:outline-none ${!isMobile && 'hidden'}`}
            onClick={() => setOpen(false)}
          />
        ) : null}
      </div>
      <div className={tw`pt-4 px-8 pb-20`}>
        <h1 className={tw`text-3xl text-background-text`}>
          {localizeString(profile.title)}
        </h1>
        <p className={tw`text-sm pt-3 pb-2 w-64 text-background-text`}>
          {localizeString(profile.subtitle)}
        </p>
      </div>
    </>
  )
}
